import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";

export default function validate(values) {
  return validator(values, form => {
    form.validate("alternate_type").satisfies(rules.required);
    form.validate("alternate_part_id", "label").satisfies(() => {
      if (!values.alternate_part_id && !values.label) {
        return "Required";
      }

      return undefined;
    });
  });
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Alternates/validate.js